export const CurtainsOpen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="60"
    height="58"
    viewBox="0 0 60 58"
  >
    <defs>
      <filter
        id="0ctjx8lgqa"
        width="150%"
        height="151.1%"
        x="-25%"
        y="-14.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3" />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
        />
      </filter>
      <rect id="kb63jjlkbb" width="46" height="45" x="1.408" y="2" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-39 -550) translate(44.5 550)">
            <use fill="#000" filter="url(#0ctjx8lgqa)" xlinkHref="#kb63jjlkbb" />
            <use fill="#FFF" xlinkHref="#kb63jjlkbb" />
          </g>
          <g fill="#2396FD">
            <path
              d="M9.1 4.2L18.2 17.5 0 17.5zM0 0H18.2V4.2H0z"
              transform="translate(-39 -550) translate(44.5 550) matrix(0 1 1 0 16.5 15.5)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
